import axios from 'axios';

const API_BASE = process.env.REACT_APP_AUTH_API_URL || '/api/auth';

const client = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
  headers: { 'Content-Type': 'application/json' },
});

export async function login(username, password, rememberMe = false) {
  const { data } = await client.post('/login', { username, password, rememberMe });
  return data;
}

export async function logout() {
  const { data } = await client.post('/logout');
  return data;
}

export async function getCurrentUser() {
  const { data } = await client.get('/me');
  return data;
}

export async function fetchUsers() {
  const { data } = await client.get('/users');
  return data.users;
}

export async function createUser(payload) {
  const { data } = await client.post('/users', payload);
  return data.user;
}

export async function updateUser(userId, payload) {
  const { data } = await client.put(`/users/${userId}`, payload);
  return data.user;
}

export async function deleteUser(userId) {
  const { data } = await client.delete(`/users/${userId}`);
  return data;
}

export async function fetchRoles() {
  const { data } = await client.get('/roles');
  return data.roles;
}

export async function updateRole(roleId, payload) {
  const { data } = await client.put(`/roles/${roleId}`, payload);
  return data.role;
}

export default {
  login,
  logout,
  getCurrentUser,
  fetchUsers,
  createUser,
  updateUser,
  deleteUser,
  fetchRoles,
  updateRole,
};
